"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appendQueryParamsToUrl = appendQueryParamsToUrl;
function appendQueryParamsToUrl(url, queryParams) {
  if (url.includes('?')) {
    return "".concat(url, "&").concat(queryParams);
  }
  return "".concat(url, "?").concat(queryParams);
}